import axios from "axios";
import api from "./api.ts";
import { ACL } from "../pinia/auth.ts";

class AuthService {
  getTheme() {
    return api.get("/theme");
  }

  getIp(api, port) {
    return axios.get(api.replace(/\/*$/, "") + ":" + port);
  }

  getSystemStatus() {
    return api.get("/system_status");
  }

  logIps(ips) {
    return api.post("/log_ips", { IPs: ips });
  }

  login(credentials) {
    return api.post("/login", credentials).then((response) => {
      return response.data;
    });
  }

  twoFactorVerify(code) {
    return api.post("/otp/verify", code).then((response) => {
      return response.data;
    });
  }

  twoFactorOnboard() {
    return api.get("/otp/generate").then((response) => {
      return response.data;
    });
  }

  adminLogin(credentials) {
    return api.post("/admin/login", credentials).then((response) => {
      return response.data;
    });
  }

  adminTwoFactorVerify(code) {
    return api.post("/admin/otp/verify", code).then((response) => {
      return response.data;
    });
  }

  adminTwoFactorOnboard() {
    return api.get("/admin/otp/generate").then((response) => {
      return response.data;
    });
  }

  logout() {
    return api.post("/logout").then((response) => {
      return response.data;
    });
  }

  adminLogout() {
    return api.post("/admin/logout").then((response) => {
      return response.data;
    });
  }

  grantAcl(aclId, ips, ticketNumber, totpCode?) {
    let res: { ACLID: string; IPs: any; TicketNumber: string | null; TOTPCode: string | null } = {
      ACLID: aclId,
      IPs: ips,
      TicketNumber: null,
      TOTPCode: null,
    };
    if (ticketNumber) {
      res.TicketNumber = ticketNumber;
    }
    if (totpCode) {
      res.TOTPCode = totpCode;
    }

    return api.post("/grant", res).then((response) => {
      return response.data;
    });
  }

  revokeAcl(aclId) {
    return api.delete(`/sessions/current/granted-acls/${aclId}`).then((response) => {
      return response.data;
    });
  }

  status() {
    return api.get("/status").then((response) => {
      const user = response.data;
      if (!user.ACLs) user.ACLs = [];
      user.ACLs.forEach((acl: ACL) => {
        // Inject token into Knocproxy URLs if we've got one
        if (acl.Config?.UriToken) {
          const url = new URL(acl.URL);
          url.searchParams.set("knoctoken", acl.Config.UriToken);
          acl.URL = url.toString();
        }
      });
      return user;
    });
  }

  adminStatus() {
    return api.get("/admin/status").then((response) => {
      return response.data;
    });
  }

  changePassword(data) {
    return api.put("/password", data).then((response) => {
      return response.data;
    });
  }

  useSAML() {
    return api.get("/saml/metadata");
  }

  useAdminSAML() {
    return api.get("/admin/saml/metadata");
  }
}

export default new AuthService();
